import React from "react";
import moment from "moment";
import { KeyboardDatePicker } from "@material-ui/pickers";

import { Format } from "app/app.constants";

const DatePickerField = ({
  input,
  format,
  margin,
  variant,
  DatePickerProps,
}) => {
  const { onChange, value } = input;

  return (
    <KeyboardDatePicker
      autoOk
      fullWidth
      margin={margin}
      format={format}
      variant={variant}
      // inputVariant="standard"
      onChange={onChange}
      placeholder={format}
      value={moment.isMoment(value) ? value : null}
      {...DatePickerProps}
    />
  );
};

DatePickerField.defaultProps = {
  margin: "normal",
  format: Format.date,
};

export default DatePickerField;
